import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { putRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';
import { put, takeEvery, call } from 'redux-saga/effects';

function* listener(serviceType, action) {
  try {
    yield put(createServiceAction(serviceType, 'loading')());
    if (action.data) {
      const options = {
        id: action.data.id,
        status: action.data.status,
        comment: action.data.comment
      };
      const infoPopDuration = 1000;
      const res = yield call(putRequest, apiConfig.trfStatus.endPointUrl, options);
      // Display HTTP status error message
      const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res, infoPopDuration);
      if (!statusErrorMessage) {
        const response = yield res.json();
        // Display server error message
        const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
        if (!serverErrorMessage && response.errorCode === 0) {
          
          yield put(createServiceAction(serviceType, 'success')(response.data));  
          yield put( createServiceAction('getArchive', 'requested')({q:action.data.searchTerm, fromDate:action.data.fromDate, toDate:action.data.toDate}))  
          const message = `${response.message}`;
          // Display success message
          yield call(displayMessage, 'success', message, 1000);
        }
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* setTrfStatus() {
  const serviceType = 'setTrfStatus';
  yield takeEvery(createServiceAction(serviceType, 'submitted').type, listener, serviceType);
}

export default setTrfStatus;
